/**
 * Small pure helpers for the help-center article view: reading-time estimate and
 * heading slugs for the table of contents. No DOM, no stores, so they are unit-testable.
 */

const WORDS_PER_MINUTE = 200;

/**
 * Estimated reading time in whole minutes. Empty body → 0, any text → at least 1.
 */
export function estimateReadingMinutes(body) {
    if (!body || typeof body !== 'string') {
        return 0;
    }
    const text = body
        .replace(/\{\{[^}]*\}\}/g, ' ') // {{video.0}} style placeholders
        .replace(/`[^`]*`/g, ' ') // inline code
        .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1') // keep link text, drop url
        .replace(/[#*_>~|-]+/g, ' ');
    const words = text.split(/\s+/).filter(Boolean);
    if (words.length === 0) {
        return 0;
    }
    return Math.max(1, Math.ceil(words.length / WORDS_PER_MINUTE));
}

/**
 * Lowercase slug for a heading. Keeps æøå and other letters, turns runs of anything
 * else into a single dash. Returns 'avsnitt' when nothing usable remains.
 */
export function slugifyHeading(text) {
    const slug = String(text || '')
        .trim()
        .toLowerCase()
        .replace(/[^\p{L}\p{N}]+/gu, '-')
        .replace(/^-+|-+$/g, '');
    return slug || 'avsnitt';
}

/**
 * Makes a slug unique within one article by appending -2, -3, … and records it in `used`.
 */
export function uniqueSlug(slug, used) {
    let candidate = slug;
    let n = 2;
    while (used.has(candidate)) {
        candidate = `${slug}-${n}`;
        n += 1;
    }
    used.add(candidate);
    return candidate;
}
